import React, { useEffect } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApprovalDashboard } from "../redux/slices/dashboardSlice";
import ApprovalPieChart from "../components/ApprovalPieChart";
import ApprovalBarCharts from "../components/ApprovalBarCharts";
import ApprovalPieCharts2 from "../components/ApprovalPieCharts2";

const ApprovalOMDashboard = () => {
  const dispatch = useDispatch();
  const approvalDashboardData = useSelector(
    (state) => state?.dashboard?.approvalDashboard
  );
  // console.log("approvalDashboardData", approvalDashboardData);
  useEffect(() => {
    dispatch(fetchApprovalDashboard());
  }, [dispatch]);

  const data = [
    {
      name: "Total Applicants For Individual",
      number:
        (approvalDashboardData?.totalApplicant?.individual?.pending || 0) +
        (approvalDashboardData?.totalApplicant?.individual?.approved || 0) +
        (approvalDashboardData?.totalApplicant?.individual?.declined || 0),
      colors: ["#7F3183", "#F17D8B", "#EBE3EB"],
      pieChartData: [
        {
          name: "Pending",
          value: approvalDashboardData?.totalApplicant?.individual?.pending,
        },
        {
          name: "Approved",
          value: approvalDashboardData?.totalApplicant?.individual?.approved,
        },
        {
          name: "Declined ",
          value: approvalDashboardData?.totalApplicant?.individual?.declined,
        },
      ],
    },
    {
      name: "Total Applicants For Student",
      number:
        (approvalDashboardData?.totalApplicant?.student?.pending || 0) +
        (approvalDashboardData?.totalApplicant?.student?.approved || 0) +
        (approvalDashboardData?.totalApplicant?.student?.declined || 0),
      colors: ["#7F3183", "#F17D8B", "#EBE3EB"],
      pieChartData: [
        {
          name: "Pending",
          value: approvalDashboardData?.totalApplicant?.student?.pending,
        },
        {
          name: "Approved",
          value: approvalDashboardData?.totalApplicant?.student?.approved,
        },
        {
          name: "Declined ",
          value: approvalDashboardData?.totalApplicant?.student?.declined,
        },
      ],
    },

    {
      name: "Total Applicants For Corporate",
      number:
        (approvalDashboardData?.totalApplicant?.corporate?.pending || 0) +
        (approvalDashboardData?.totalApplicant?.corporate?.approved || 0) +
        (approvalDashboardData?.totalApplicant?.corporate?.declined || 0),
      colors: ["#7F3183", "#F17D8B", "#EBE3EB"],
      pieChartData: [
        {
          name: "Pending",
          value: approvalDashboardData?.totalApplicant?.corporate?.pending,
        },
        {
          name: "Approved",
          value: approvalDashboardData?.totalApplicant?.corporate?.approved,
        },
        {
          name: "Declined ",
          value: approvalDashboardData?.totalApplicant?.corporate?.declined,
        },
      ],
    },

    {
      name: "Total Applicants For Associate",
      number: 20,
      colors: ["#18203A", "#EBE3EB"],
      pieChartData: [
        { name: "Approved", value: 15 },
        { name: "Declined ", value: 5 },
      ],
    },
    {
      name: "Total Applicants For Fellow",
      number: 35,
      colors: ["#E9BF72", "#EBE3EB"],
      pieChartData: [
        { name: "Approved", value: 25 },
        { name: "Declined ", value: 10 },
      ],
    },
  ];

  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Box w={["100%", "100%", "100%"]}>
        <ApprovalPieChart details={data} />
      </Box>
      <Flex
        mt={6}
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "space-between"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%", "70%", "75%"]}>
          <ApprovalBarCharts
            barChartData={approvalDashboardData?.totalApplicantPerMonth}
          />
        </Box>
        <Box w={["100%", "100%", "100%", "30%", "25%"]}>
          <ApprovalPieCharts2 />
        </Box>
      </Flex>
    </Flex>
  );
};

export default ApprovalOMDashboard;
